module.exports = __webpack_public_path__ + "img/wedding_inner_2.56ac6436.jpg";